// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design tokens shared by portal-v2 (candidate/recruiter) and enterprise (admin/partner). */
/* These extend portal-v2 without overriding any selectors used by legacy index.css. */

:root {
  /* Typography scale (modular, 1.125 ratio) */
  --t-12: 0.75rem;
  --t-13: 0.8125rem;
  --t-14: 0.875rem;
  --t-15: 0.9375rem;
  --t-16: 1rem;
  --t-18: 1.125rem;
  --t-20: 1.25rem;
  --t-24: 1.5rem;
  --t-30: 1.875rem;
  --t-36: 2.25rem;

  /* Spacing scale (4-px base) */
  --s-1: 4px;
  --s-2: 8px;
  --s-3: 12px;
  --s-4: 16px;
  --s-5: 20px;
  --s-6: 24px;
  --s-7: 32px;
  --s-8: 40px;
  --s-9: 48px;
  --s-10: 64px;

  /* Radius */
  --r-sm: 6px;
  --r-md: 10px;
  --r-lg: 14px;
  --r-xl: 20px;
  --r-pill: 999px;

  /* Shadow ramp */
  --sh-1: 0 1px 2px rgba(15,23,42,0.05);
  --sh-2: 0 2px 8px rgba(15,23,42,0.06), 0 8px 24px rgba(15,23,42,0.05);
  --sh-3: 0 4px 14px rgba(15,23,42,0.10), 0 16px 40px rgba(15,23,42,0.08);
  --sh-focus: 0 0 0 3px rgba(37,99,235,0.35);

  /* Motion */
  --m-fast: 150ms;
  --m-base: 220ms;
  --m-slow: 320ms;
  --m-ease: cubic-bezier(.2,.8,.2,1);

  /* Achievement palette (metallics) */
  --metal-bronze: #b08060;
  --metal-bronze-soft: #f3e6db;
  --metal-silver: #94a3b8;
  --metal-silver-soft: #eef2f7;
  --metal-gold: #d4a017;
  --metal-gold-soft: #fdf3d3;
  --metal-platinum: #cbd5e1;
  --metal-platinum-soft: #f1f5f9;
  --metal-diamond: #5fa8d3;
  --metal-diamond-soft: #e3f1fb;

  /* Gamification accents */
  --xp-fill: linear-gradient(90deg,#2563eb 0%,#0ea5e9 100%);
  --streak-fill: linear-gradient(135deg,#d4a017,#f59e0b);
  --strength-low: #b91c1c;
  --strength-mid: #b45309;
  --strength-high: #15803d;

  /* Enterprise greys (Phase 6) */
  --ent-bg: #fafbfd;
  --ent-surface: #ffffff;
  --ent-border: #e3e7ee;
  --ent-border-strong: #c7cfdb;
  --ent-text: #0b1220;
  --ent-text-2: #2c3a52;
  --ent-muted: #6a7689;
  --ent-row-zebra: #f6f8fb;
}

@media (prefers-reduced-motion: reduce) {
  :root {
    --m-fast: 0ms;
    --m-base: 0ms;
    --m-slow: 0ms;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.tokens.css"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,sFAAsF;;AAEtF;EACE,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;;EAEf,8BAA8B;EAC9B,UAAU;EACV,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;;EAEZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;;EAEf,gBAAgB;EAChB,qCAAqC;EACrC,qEAAqE;EACrE,uEAAuE;EACvE,0CAA0C;;EAE1C,WAAW;EACX,eAAe;EACf,eAAe;EACf,eAAe;EACf,kCAAkC;;EAElC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,wBAAwB;EACxB,6BAA6B;;EAE7B,yBAAyB;EACzB,yDAAyD;EACzD,sDAAsD;EACtD,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;EAExB,+BAA+B;EAC/B,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;IACb,aAAa;IACb,aAAa;EACf;AACF","sourcesContent":["/* Design tokens shared by portal-v2 (candidate/recruiter) and enterprise (admin/partner). */\n/* These extend portal-v2 without overriding any selectors used by legacy index.css. */\n\n:root {\n  /* Typography scale (modular, 1.125 ratio) */\n  --t-12: 0.75rem;\n  --t-13: 0.8125rem;\n  --t-14: 0.875rem;\n  --t-15: 0.9375rem;\n  --t-16: 1rem;\n  --t-18: 1.125rem;\n  --t-20: 1.25rem;\n  --t-24: 1.5rem;\n  --t-30: 1.875rem;\n  --t-36: 2.25rem;\n\n  /* Spacing scale (4-px base) */\n  --s-1: 4px;\n  --s-2: 8px;\n  --s-3: 12px;\n  --s-4: 16px;\n  --s-5: 20px;\n  --s-6: 24px;\n  --s-7: 32px;\n  --s-8: 40px;\n  --s-9: 48px;\n  --s-10: 64px;\n\n  /* Radius */\n  --r-sm: 6px;\n  --r-md: 10px;\n  --r-lg: 14px;\n  --r-xl: 20px;\n  --r-pill: 999px;\n\n  /* Shadow ramp */\n  --sh-1: 0 1px 2px rgba(15,23,42,0.05);\n  --sh-2: 0 2px 8px rgba(15,23,42,0.06), 0 8px 24px rgba(15,23,42,0.05);\n  --sh-3: 0 4px 14px rgba(15,23,42,0.10), 0 16px 40px rgba(15,23,42,0.08);\n  --sh-focus: 0 0 0 3px rgba(37,99,235,0.35);\n\n  /* Motion */\n  --m-fast: 150ms;\n  --m-base: 220ms;\n  --m-slow: 320ms;\n  --m-ease: cubic-bezier(.2,.8,.2,1);\n\n  /* Achievement palette (metallics) */\n  --metal-bronze: #b08060;\n  --metal-bronze-soft: #f3e6db;\n  --metal-silver: #94a3b8;\n  --metal-silver-soft: #eef2f7;\n  --metal-gold: #d4a017;\n  --metal-gold-soft: #fdf3d3;\n  --metal-platinum: #cbd5e1;\n  --metal-platinum-soft: #f1f5f9;\n  --metal-diamond: #5fa8d3;\n  --metal-diamond-soft: #e3f1fb;\n\n  /* Gamification accents */\n  --xp-fill: linear-gradient(90deg,#2563eb 0%,#0ea5e9 100%);\n  --streak-fill: linear-gradient(135deg,#d4a017,#f59e0b);\n  --strength-low: #b91c1c;\n  --strength-mid: #b45309;\n  --strength-high: #15803d;\n\n  /* Enterprise greys (Phase 6) */\n  --ent-bg: #fafbfd;\n  --ent-surface: #ffffff;\n  --ent-border: #e3e7ee;\n  --ent-border-strong: #c7cfdb;\n  --ent-text: #0b1220;\n  --ent-text-2: #2c3a52;\n  --ent-muted: #6a7689;\n  --ent-row-zebra: #f6f8fb;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  :root {\n    --m-fast: 0ms;\n    --m-base: 0ms;\n    --m-slow: 0ms;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
